import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const rowStyle = css`
  margin-right: 0;
  padding: 0;
  align-items: center;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  min-height: 33px;
`;

export const labelContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  padding: ${theme.spacing(0.75, 0, 0.75, 0)};
`;

export const chipStyle = css`
  max-width: 100%;
  justify-content: flex-start;
  padding: ${theme.spacing(0.75, 1, 0.75, 1)};
  height: 32px;

  span {
    font-size: ${theme.font.size.large};
  }

  :focus {
    outline: none;
  }
`;

export const placeholderStyle = css`
  color: ${theme.colors.neutral50};
`;
